<lex-doc-viewer-dialog>
  <div dialog-title>Document History</div>
  <div dialog-body style="max-height: 55vh; overflow: auto; margin-bottom: 10px;">
    <div style="display: flex; flex-direction: column;
      gap: 10px; padding: 10px 18px;">
      <ng-container *ngFor="let audit of (audits$ | async)">
        <mat-card appearance="outlined" class="audit-item">
          <div style="margin-bottom: 4px; font-size: 13px;">
            <b>{{audit.details}}</b>
          </div>
          <div style="font-size: 11px;">
            {{audit.userName}} at {{audit.auditDate | date:'M/d/yyyy h:mm:ss a'}}
          </div>
        </mat-card>
      </ng-container>
    </div>
  </div>
</lex-doc-viewer-dialog>
